export const teamTypes = {
    // Get team members list
    FETCH_TEAM_MEMBERS_REQUEST: "FETCH_TEAM_MEMBERS_REQUEST",
    FETCH_TEAM_MEMBERS_SUCCESS: "FETCH_TEAM_MEMBERS_SUCCESS",
    FETCH_TEAM_MEMBERS_FAILURE: "FETCH_TEAM_MEMBERS_FAILURE",

    // Get team members list v2
    FETCH_TEAM_MEMBERS2_REQUEST: "FETCH_TEAM_MEMBERS2_REQUEST",
    FETCH_TEAM_MEMBERS2_SUCCESS: "FETCH_TEAM_MEMBERS2_SUCCESS",
    FETCH_TEAM_MEMBERS2_FAILURE: "FETCH_TEAM_MEMBERS2_FAILURE",

    // Reset actions
    RESET_FETCH_TEAM_MEMBERS: "RESET_FETCH_TEAM_MEMBERS",
    RESET_FETCH_TEAM_MEMBERS2: "RESET_FETCH_TEAM_MEMBERS2",
};

export interface TeamMember {
    [key: string]: any;
}
// {
//     _id: string;
//     profile: {
//         avatar: string;
//         businessName: string;
//     };
//     email: string;
//     brandName: string;
//     firstName: string;
//     fullName: string;
//     lastName: string;
//     role: string;
//     isActive: boolean;
//     createdAt: string;
//     updatedAt: string;
// }

export interface TeamFilters {
    search?: string;
    role?: string;
    page?: number;
    limit?: number;
    sortBy?: string;
    sortDirection?: "asc" | "desc";
    isActive?: boolean;
}

export interface GetTeamMembersResponse {
    teamMembers: TeamMember[];
    total: number;
    pagination: {
        current: number;
        next: number;
        perPage: number;
        number_of_pages: number;
    };
}
